import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem , TextField , Box } from "@mui/material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

//Services
import TriplistApi from "Services/Triplist";

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);  
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);


  // Get Passenger list api

  const gettriplists = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
   // console.log('drivers--->',res?.data);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    TriplistApi.getdriversinfo({ page, limit: pageSize  })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

   const getalltriplists = useCallback(() => {
   // dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
    //  dispatch(hideLoader());
      if (res?.data?.status === true) {
    //    setTotalPages(res?.data?.data?.totalRecords || 1);
   // console.log('drivers--->',res?.data);
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
   TriplistApi.getdriversinfo({ page:1, limit: "unlimited"  })
     .then(onSuccess, onFailure);
  }, []); 

  useEffect(() => {
    gettriplists();
    getalltriplists();
  }, [gettriplists]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All KmdrivenList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }; 

  const handlePageChange = (newPage) => {
  //  console.log('newPage-->',newPage);
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const handleview = (event, rowData) => {
   // console.log('Driverride_id-->',rowData.driver_ride_details._id)
   // console.log('Driver_id-->',rowData._id)
    navigate('/kmdriverreport', {
      state: {
        driverRideId: rowData.driver_ride_details._id,
        driverId: rowData._id,
      },
    });
  };
 
  const handleCopy = () => {
    // Define column widths
    const columnWidths = [5, 15, 25, 15, 15, 15]; // Adjust widths as needed
  
    // Helper function to pad text to the desired width
    const padText = (text, width) => {
      return (text ?? "").toString().padEnd(width, " ");
    };
    // Create table header
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("Driver Name", columnWidths[1]),
      padText("Mobile", columnWidths[2]),
      padText("Total Rides", columnWidths[3]),
      padText("Km driven", columnWidths[4]),
      padText("Duration", columnWidths[5])
    ].join("");
  
    // Create table rows
    const rows = dataRows
      .map((row) =>
        [
          padText(row.sno, columnWidths[0]),
          padText(row.drivername, columnWidths[1]),
          padText(row.mobile, columnWidths[2]),
          padText(row.totalrides, columnWidths[3]),
          padText(row.kmdriven+" KM", columnWidths[4]),
          padText(row.duration+" mins", columnWidths[5]),
        ].join("")
      )
      .join("\n");
  
    // Combine header and rows
    const formattedContent = [header, rows].join("\n");
  
    // Copy to clipboard
    navigator.clipboard.writeText(formattedContent).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "KmdrivenList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "KmdrivenList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,row.drivername,row.mobile,row.totalrides,row.kmdriven,row.duration,
]);
    doc.autoTable({
head: [["S.NO","Driver Name","Mobile","Total rides","Km driven","Duration"]],
body: tableData,
    });
    doc.save("KmdrivenList.pdf");
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    drivername: data?.firstName+" "+data?.lastName,
    mobile:data?.countryCode+" "+data?.mobileNumber,
    totalrides: data?.ridesaccepted?.length || 0,
    kmdriven: (data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripDistance ? ride?.tripDistance: 0),0),
    duration:(data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripMinutes ? ride?.tripMinutes: 0),0), 
    row: data,
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 1,
      minWidth: 60, 
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "drivername",
      headerName: "Driver name",
      flex: 2,
      minWidth: 120, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.drivername}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "totalrides",
      headerName: "Total rides",
      flex: 2,
      minWidth: 120, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.totalrides}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "kmdriven",
      headerName: "KM driven",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2" >{params?.row?.kmdriven.toFixed(2)+" KM"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration in (min)",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.duration.toFixed(2)}</Typography>
            </div>
          </>
        );
      },
    },
    {
    field: "actions",
    headerName: "Request Details",
    minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const rowData = params?.row?.row;
      return (
        <>
    <div className={classes.iconsWrapper}>
    <Button
      id="basic-button"
      aria-controls={openaction ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={openaction ? 'true' : undefined}
      onClick={(e) => handleview(e, rowData)}
    >
      View
    </Button>
        </div>
        </>
      );
    },
    }
  ];

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Driver Name":row.drivername,
    "Mobile":row.mobile,
    "Total rides": row.totalrides,
    "Km driven": row.kmdriven+" KM",
    "Duration": row.duration+" min",
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
     sno: calculateSno(page, pageSize, index),
    drivername: data?.firstName+" "+data?.lastName,
    mobile:data?.countryCode+" "+data?.mobileNumber,
    totalrides: data?.ridesaccepted?.length || 0,
    kmdriven: (data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripDistance ? ride?.tripDistance: 0),0),
    duration:(data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripMinutes ? ride?.tripMinutes: 0),0), 
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
   "S.NO": row.sno,
    "Driver Name":row.drivername,
    "Mobile":row.mobile,
    "Total rides": row.totalrides,
    "Km driven": row.kmdriven+" KM",
    "Duration": row.duration+" min",
  })); 


  return (  
    <>

<div className={classes.pages}>
<Grid container className={classes.root}>

<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleCopy}>
      COPY
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadExcel}>
      EXCEL
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadCSV}>
      CSV
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadPDF}>
      PDF
    </Button>
  </Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
              <Button variant="contained" onClick={handleDownloadAll}>
              Download ALL
              </Button>
              </Grid>  
<Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
       className={classes.tripgridtable}
        getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
         // console.log("newPageSize--->",newPageSize);
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={100}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
</Grid>

</Grid>
</div>

    </>
  );
};

export default Passenger;
